import React from "react"
import PropTypes from "prop-types"
import { domToReact } from "html-react-parser"
import { TextOnlyHero } from "@kohler-dsm-library/kohler-modules"
import { getShortenedUrlwithGeneral, sanitizeInnerHtml } from "@/utils/helper"
import { addTeaserActionAnalytics } from "../Teaser/v1/analytics"
import { useSelector } from "react-redux"
import { selectGenericState } from "@/store/features/genericSlice"

const headingTags = new Set(["h1", "h2", "h3", "h4", "h5", "h6"])

const unwrapHeadingOptions = {
  replace: domNode => {
    if (domNode?.type === "tag" && headingTags.has(domNode.name)) {
      return <>{domToReact(domNode.children, unwrapHeadingOptions)}</>
    }
    return undefined
  },
}

const TextOnlyHeroComponent = ({ data }) => {
  const {
    id = "",
    title = "",
    description = "",
    actions = [],
    pageType = "",
    componentPosition = "",
    eventName = "",
    dataLayerLinkType = "",
    eventAction = "",
    productCategory = "",
    productCollectionsName = "",
    productRoom = "",
    datalayerPageType = "",
    mainTitle = "",
    componentInfo = "",
    videoTitle = "",
  } = data

  const {
    globalConfig: { general = {} },
  } = useSelector(selectGenericState)

  const textOnlyProps = {
    id: id,
    mod: "white",
    variant: "short",
    className: "cmp-teaser__content",
    heading: {
      component: "h1",
      text: sanitizeInnerHtml(title, unwrapHeadingOptions),
    },
    description: {
      text: sanitizeInnerHtml(description),
      className: "cmp-teaser__description",
    },

    ...(actions.length > 0 && {
      CTA: actions
        .filter(
          action =>
            action.primaryCTA === "true" || action.secondaryCTA === "true"
        )
        .map(action => ({
          text: action.title,
          href: getShortenedUrlwithGeneral(action.url, general),
          newTab: action.newTab === "true",
          target: action.newTab === "true" ? "_blank" : "_self",
          onClick: () => {
            addTeaserActionAnalytics({
              pageType,
              componentPosition,
              videoTitle,
              link: getShortenedUrlwithGeneral(action.url, general),
              text: action.title,
              eventName,
              dataLayerLinkType,
              eventAction,
              productCategory,
              productCollectionsName,
              productRoom,
              datalayerPageType,
              mainTitle,
              componentInfo,
            })
          },
        }))[0],
    }),
  }

  return (
    <div className="teaser plp-text-hero">
      <div className="cmp-teaser">
        <TextOnlyHero {...textOnlyProps} />
      </div>
    </div>
  )
}

TextOnlyHeroComponent.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        primaryCTA: PropTypes.string,
        secondaryCTA: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string,
        newTab: PropTypes.string,
      })
    ),
    pageType: PropTypes.string,
    componentPosition: PropTypes.string,
    eventName: PropTypes.string,
    dataLayerLinkType: PropTypes.string,
    eventAction: PropTypes.string,
    productCategory: PropTypes.string,
    productCollectionsName: PropTypes.string,
    productRoom: PropTypes.string,
    datalayerPageType: PropTypes.string,
    mainTitle: PropTypes.string,
    componentInfo: PropTypes.string,
    videoTitle: PropTypes.string,
  }),
}

export default TextOnlyHeroComponent
